export default function calculateUsedCreditsInPercentage(
  totalCredits: number,
  availableCredits: number,
) {
  if (availableCredits > totalCredits) {
    return 100;
  }
  return totalCredits > 0 ? (availableCredits / totalCredits) * 100 : 0;
}
